<template>
  <view class="loading__mask" @touchmove.stop.prevent="preventTouchMove">
    <view class="loading-outer">
      <view class="loading-inner logo-animation">
        <c-img src="/static/common/wish-logo.png" />
      </view>

      <view class="loading-shadow shadow-animation"></view>

      <view class="loading-text">努力加载中...</view>
    </view>
  </view>
</template>

<script setup lang="ts">
const preventTouchMove = () => {
  return;
};
</script>

<style scoped lang="scss">
.loading__mask {
  /* pointer-events: none; */
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: $W;
}

.loading-outer {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150rpx;
  height: 150rpx;
}

.loading-inner {
  position: absolute;
  transform: translateY(0) translateZ(0);
  // transform: translateY(0) translateZ(0) rotate(0deg);
  width: 100%;
  height: 100%;
  border-radius: 20rpx;
  overflow: hidden;

  &.logo-animation {
    animation: logo-bounce ease 1.2s infinite;
  }

  @keyframes logo-bounce {
    // 0% {
    //   transform: translateY(0) translateZ(0) rotate(0deg);
    // }
    // 50% {
    //   transform: translateY(-100rpx) translateZ(0) rotate(180deg);
    //   border-radius: 50%;
    // }
    // 100% {
    //   transform: translateY(0) translateZ(0) rotate(359deg);
    // }
    0% {
      transform: translateY(0) translateZ(0);
    }
    50% {
      transform: translateY(-100rpx) translateZ(0);
      border-radius: 50%;
    }
    100% {
      transform: translateY(0) translateZ(0);
    }
  }
}

.loading-shadow {
  position: absolute;
  bottom: -40rpx;
  left: 50%;
  transform: translateX(-50%);
  width: 100rpx;
  height: 10rpx;
  background: #c1c1c1;
  border-radius: 100%;
  opacity: 0.6;

  &.shadow-animation {
    animation: shadow-bounce ease 1.2s infinite;
  }

  @keyframes shadow-bounce {
    0% {
      width: 100rpx;
      height: 10rpx;
      opacity: 0.6;
    }
    50% {
      width: 50rpx;
      height: 5rpx;
      opacity: 0.2;
    }
    100% {
      width: 100rpx;
      height: 10rpx;
      opacity: 0.6;
    }
  }
}

.loading-text {
  position: absolute;
  bottom: -100rpx;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200%;
  font-size: 24rpx;
  color: $N7;
}
</style>
